/* jk-routine-finder.js — Quiz-Navigation. Das Ergebnis ist seit dem
   Redesign 13.08.2026 SERVERSEITIG gerendert (jk-product-card-System,
   Hero-Set + begruendete Schritt-Karten) — das fruehere JSON-Karten-
   Templating, die Summenzeile und der Sammel-ATC sind entfernt.
   Frage 1 waehlt die Routine; die Scope-Antwort (Frage 4) steuert
   seit dem Begruendungs-Umbau (15.08.2026) den Block «Fuer den
   Koerper» (nur bei scope_full — ein Body-Set als Ergaenzung einer
   Gesichts-Routine waere ein Glaubwuerdigkeitsbruch). Routinen-
   spezifische Ergaenzungs-Zeilen tragen data-jk-rf-only. */
(function () {
  'use strict';

  class JkRoutineFinder extends HTMLElement {
    connectedCallback() {
      this.answers = {};
      this.totalSteps = this.querySelectorAll('.jk-rf__screen--question').length;
      this.addEventListener('click', this._handleClick.bind(this));
    }

    _handleClick(e) {
      const optBtn = e.target.closest('.jk-rf__option');
      if (optBtn) { this._selectOption(optBtn); return; }

      const backBtn = e.target.closest('[data-action="back"]');
      if (backBtn) { this._back(); return; }

      const restartBtn = e.target.closest('[data-action="restart"]');
      if (restartBtn) { this._restart(); return; }

      const addonsToggle = e.target.closest('[data-action="addons-toggle"]');
      if (addonsToggle) { this._toggleAddons(addonsToggle); return; }
    }

    _toggleAddons(btn) {
      const box = btn.closest('[data-jk-rf-addons]');
      if (!box) return;
      const open = box.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    _selectOption(btn) {
      const step = parseInt(btn.dataset.step, 10);
      const value = btn.dataset.value;

      const screen = btn.closest('.jk-rf__screen');
      screen.querySelectorAll('.jk-rf__option').forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');

      this.answers[step] = value;

      setTimeout(() => {
        if (step < this.totalSteps) {
          this._showScreen(step + 1);
        } else {
          this._showResult();
        }
      }, 220);
    }

    _back() {
      const activeScreen = this.querySelector('.jk-rf__screen.is-active');
      if (!activeScreen) return;
      const currentStep = parseInt(activeScreen.dataset.screen, 10);
      if (currentStep > 1) this._showScreen(currentStep - 1);
    }

    _restart() {
      this.answers = {};
      this.querySelectorAll('.jk-rf__option').forEach(b => b.classList.remove('is-selected'));
      this.querySelectorAll('[data-jk-rf-result]').forEach(el => { el.hidden = true; });
      const shared = this.querySelector('[data-jk-rf-shared]');
      if (shared) shared.hidden = true;
      this.querySelectorAll('[data-jk-rf-addons]').forEach(box => {
        box.classList.remove('is-open');
        const btn = box.querySelector('[data-action="addons-toggle"]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
      this.classList.remove('jk-rf--result-active');
      this._showScreen(1);
    }

    _showScreen(step) {
      this.querySelectorAll('.jk-rf__screen').forEach(s => s.classList.remove('is-active'));
      const target = this.querySelector('[data-screen="' + step + '"]');
      if (target) target.classList.add('is-active');
      this._updateProgress(typeof step === 'number' ? step : 0);
      this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    _updateProgress(activeStep) {
      this.querySelectorAll('.jk-rf__progress-segment').forEach(seg => {
        const s = parseInt(seg.dataset.step, 10);
        seg.classList.toggle('is-active', s <= activeStep);
      });
    }

    _computeRoutineId() {
      const routineMap = {
        goal_aging:   'a',
        goal_basics:  'b',
        goal_reset:   'c',
        goal_clarity: 'd'
      };
      return routineMap[this.answers[1]] || 'b';
    }

    _showResult() {
      const rid = this._computeRoutineId();
      let matched = false;
      this.querySelectorAll('[data-jk-rf-result]').forEach(el => {
        const show = el.dataset.jkRfResult === rid;
        el.hidden = !show;
        if (show) matched = true;
      });
      if (!matched) {
        const fallback = this.querySelector('[data-jk-rf-result="b"]');
        if (fallback) fallback.hidden = false;
      }
      const shared = this.querySelector('[data-jk-rf-shared]');
      if (shared) shared.hidden = false;

      // Routinen-spezifische Ergaenzungs-Zeilen (z. B. das zweite
      // Schritt-3-Produkt der gewaehlten Routine)
      this.querySelectorAll('[data-jk-rf-only]').forEach(el => {
        el.hidden = el.dataset.jkRfOnly !== rid;
      });

      // «Fuer den Koerper» nur bei explizitem Body-Bedarf (scope_full)
      const wantsBody = Object.values(this.answers).includes('scope_full');
      this.querySelectorAll('[data-jk-rf-body]').forEach(el => {
        el.hidden = !wantsBody;
      });

      this.classList.add('jk-rf--result-active');
      this._showScreen('result');
      this._updateProgress(this.totalSteps);
    }
  }

  if (!customElements.get('jk-routine-finder')) {
    customElements.define('jk-routine-finder', JkRoutineFinder);
  }
})();
